import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Navbar } from "./navbar";
import { Contact } from "./contact";
import "../styles/listeProjets.css";

export function CategorieProjets() {
    const { ville } = useParams();
    const listP = useSelector(s => s.listP) || [];
    const list = listP.filter(a => a.ville === ville);

    return (
        <>
            <Navbar />
            <div className="projets-list-container">
                <div className="projets-title-bar" style={{ backgroundColor: "#000033", padding: '20px 15px', marginTop: '-28px' }}>
                    Projets: {ville}
                </div>

                <div className="projets-grid" style={{ marginTop: '40px' }}>
                    {list.map(a => (
                        <div key={a.id} className="projet-card">
                            <div className="projet-image-wrapper">
                                <img src={a.imageProjet} alt={a.nomProjet} />
                            </div>
                            <div className="projet-info">
                                <h3 className="projet-name">{a.nomProjet}</h3>
                                <Link to={`/listeProjets/${a.id}`} className="btn-details">
                                    Plus de détails
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

                {list.length === 0 && (
                    <div style={{ textAlign: 'center', marginTop: '40px', color: '#666' }}>
                        <p>Aucun projet trouvé pour la catégorie "{ville}"</p>
                    </div>
                )}
            </div>
            <Contact />
        </>
    );
}